import IconBase from '../PerspectiveIcon/IconBase';

const PerspectiveIconPlaceholder = () => <IconBase size={48} />;

export default PerspectiveIconPlaceholder;
